
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinsharashiv() {



const cardData = {
  keyword: 'Corporate Cab Services in Dharashiv MIDC',
  heading: 'eTravo: Trusted Corporate Cab Services in Dharashiv MIDC',
  headingDescription: `eTravo delivers comprehensive corporate cab solutions in Dharashiv MIDC tailored to meet the unique needs of industries, corporate offices, and logistics hubs. Our services focus on enhancing employee mobility, executive transfers, and client transportation with an emphasis on safety, timeliness, and professionalism. Equipped with a modern fleet of GPS-enabled, air-conditioned vehicles and staffed by courteous drivers trained in corporate etiquette, we provide seamless travel experiences that reduce operational downtime and boost productivity. Whether it’s daily employee shifts, urgent business meetings, or large-scale corporate events, eTravo’s flexible rental packages and real-time support make transportation management hassle-free across Dharashiv’s industrial expanse.`,

  top: 'Key Business and Industrial Areas Covered by eTravo in Dharashiv MIDC',
  topPlaces: [
    {
      title: 'Dharashiv MIDC Industrial Park',
      description: `A bustling zone hosting diverse manufacturing units including textiles, pharmaceuticals, and engineering. eTravo’s tailored employee transport ensures efficient shift coverage with optimized routes and reliable pickups.`
    },
    {
      title: 'Dharashiv Logistics Hub',
      description: `Serving warehouses and distribution centers, our cab services streamline staff movement and support logistics personnel for timely deliveries and operations.`
    },
    {
      title: 'Dharashiv City Center',
      description: `The commercial and administrative heart of Dharashiv where corporate offices and business centers are located. We provide premium executive and client transportation services here.`
    },
    {
      title: 'Dharashiv Railway Station',
      description: `Our transfer services connect employees and clients arriving by rail with their respective workplaces or accommodations, ensuring seamless last-mile connectivity.`
    },
    {
      title: 'New Industrial Estates',
      description: `Emerging industrial areas around Dharashiv are supported with customized shuttle and on-demand cab hire services to facilitate smooth staff movement and operational logistics.`
    }
  ],

  services: [
  {
    name: 'Dharashiv MIDC Corporate Cab Rentals',
    description: `Customizable rental plans designed to suit businesses of all sizes, covering everything from daily employee transport to special event logistics within Dharashiv MIDC. Our packages include flexible timing, route customization, and vehicle options that ensure your workforce and guests travel efficiently and comfortably.`
  },
  {
    name: 'Employee Transport Cab Dharashiv MIDC',
    description: `Reliable and safe employee commute solutions aligned with factory shifts and office hours, ensuring punctuality and convenience for all staff members. Equipped with GPS tracking and monitored by a dedicated operations team, our services guarantee timely pickups, drop-offs, and seamless communication between drivers and company managers.`
  },
  {
    name: 'Business Cab Services Dharashiv MIDC',
    description: `Flexible cab options for business owners, corporate teams, and vendors for meetings, site visits, and inter-office travel within the region. Our professional drivers understand local routes and traffic patterns, delivering timely and comfortable rides that support your business productivity and client engagements.`
  },
  {
    name: 'Corporate Staff Cabs Dharashiv MIDC',
    description: `Multi-route, group transportation services with GPS tracking and professional driver supervision, tailored for staff commuting needs. Our system supports batch pickups and drop-offs, enabling efficient transport for large teams while maintaining high safety and comfort standards.`
  },
  {
    name: 'Reliable Corporate Cab Service Dharashiv MIDC',
    description: `Dependable service with a focus on vehicle cleanliness, driver professionalism, and timely pickups/drop-offs to maintain corporate standards. We prioritize consistent quality and responsiveness, ensuring your company’s transport needs are met without disruptions.`
  },
  {
    name: 'AC Corporate Cabs Dharashiv MIDC',
    description: `Air-conditioned cab services to ensure comfortable travel even during hot and humid weather conditions typical in the region. Our modern AC fleet offers a cool and relaxing environment for employees and executives, helping maintain productivity and well-being throughout their commute.`
  },
  {
    name: 'Staff Pickup and Drop Cab Dharashiv MIDC',
    description: `Comprehensive staff transport with flexible timings to support multiple shifts, night duties, and emergency rides without hassle. Our 24/7 availability ensures that your workforce moves safely and punctually, regardless of shift changes or unforeseen scheduling adjustments.`
  },
  {
    name: 'Affordable Business Cab Rentals Dharashiv MIDC',
    description: `Cost-effective corporate transportation solutions that offer transparency in pricing and are scalable to meet changing business demands. Our rental options include fuel-efficient vehicles rides, and monthly packages designed to optimize your budget without sacrificing service quality.`
  },
  {
    name: 'Executive Cab Services Dharashiv MIDC',
    description: `Luxury cab services featuring experienced chauffeurs and well-maintained vehicles for senior executives, VIP clients, and business partners. We ensure discreet, punctual, and courteous service tailored to high-profile travel requirements, complete with options for premium vehicle models.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Dharashiv MIDC',
    description: `Fixed-route monthly cab plans that simplify employee transport management and reduce administrative overhead for HR and logistics teams. These plans provide consistent, reliable service with easy billing, route adjustments, and seamless integration into corporate workflows.`
  },
  {
    name: 'Industrial Area Employee Transport Dharashiv MIDC',
    description: `Efficient routing and scheduling services to transport industrial workers safely and on time across Dharashiv’s industrial corridors. Our service complies with industrial safety standards and includes comprehensive documentation to support company audits and regulatory requirements.`
  },
  {
    name: 'Corporate Client Cabs Dharashiv MIDC',
    description: `Dedicated, high-standard transportation for visiting clients, enhancing corporate hospitality and professionalism during their stay. From airport pickups to meeting venue transfers, we ensure a polished and comfortable travel experience that reflects your company’s values.`
  },
  {
    name: 'Business Meeting Cabs Dharashiv MIDC',
    description: `Quick response cab services tailored for urgent business meetings, corporate events, and last-minute travel requirements. Our streamlined booking process and prompt driver dispatch ensure executives reach their destinations on time, every time.`
  },
  {
    name: 'Dharashiv Industrial Area Cab Hire',
    description: `On-demand cab hire services supporting audits, site inspections, and operational transport across the industrial landscape. Flexible booking options, experienced drivers, and knowledge of the industrial area make this ideal for spontaneous or planned trips within Dharashiv MIDC.`
  },
  {
    name: 'Corporate Shuttle Cabs Dharashiv MIDC',
    description: `Group shuttle services using minibuses or large vans ideal for transporting multiple employees during shift changes or corporate functions. Designed to optimize cost-efficiency and safety, our shuttle options help large teams commute smoothly while reducing individual vehicle use and traffic congestion.`
  }
],

  tableData: [
    ['Dharashiv MIDC Corporate Cab Rentals', 'Employee Transport Cab Dharashiv MIDC'],
    ['Business Cab Services Dharashiv MIDC', 'Corporate Staff Cabs Dharashiv MIDC'],
    ['Reliable Corporate Cab Service Dharashiv MIDC', 'AC Corporate Cabs Dharashiv MIDC'],
    ['Staff Pickup and Drop Cab Dharashiv MIDC', 'Affordable Business Cab Rentals Dharashiv MIDC'],
    ['Executive Cab Services Dharashiv MIDC', 'Monthly Corporate Cab Rentals Dharashiv MIDC'],
    ['Industrial Area Employee Transport Dharashiv MIDC', 'Corporate Client Cabs Dharashiv MIDC'],
    ['Business Meeting Cabs Dharashiv MIDC', 'Dharashiv Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Dharashiv MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Professional Cab Services for Dharashiv MIDC Businesses",
    "WhyChoosedescription": "eTravo offers specialized corporate cab services for Dharashiv MIDC, catering to the transportation needs of industrial and manufacturing units in the region. Our solutions are designed to ensure punctual, safe, and comfortable employee commutes, thereby enhancing productivity and reducing transportation-related hassles for businesses operating in this growing industrial area."
  },
  {
    "WhyChooseheading": "Comprehensive Fleet to Match Diverse Corporate Travel Needs",
    "WhyChoosedescription": "Our diverse fleet includes sedans, SUVs, and multi-utility vehicles, allowing companies to select the most appropriate vehicles for daily employee commutes, client visits, or inter-office travel. Each vehicle is well-maintained, air-conditioned, and equipped with modern safety features to guarantee a smooth ride."
  },
  {
    "WhyChooseheading": "Experienced Drivers with In-Depth Knowledge of Dharashiv MIDC Routes",
    "WhyChoosedescription": "Our drivers are extensively trained and familiar with Dharashiv MIDC’s industrial routes, gate protocols, and traffic conditions. This local expertise ensures efficient navigation, timely pickups and drop-offs, and adherence to corporate etiquette."
  },
  {
    "WhyChooseheading": "Flexible Booking and Scheduling for Shift-Based Transportation",
    "WhyChoosedescription": "We provide flexible booking options tailored to the varying shift patterns common in industrial sectors. Whether you need daily scheduled rides, on-demand pickups, or long-term contracts, we adapt to your company’s transportation demands seamlessly."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Enhanced Safety and Transparency",
    "WhyChoosedescription": "All our cabs come equipped with GPS tracking systems that allow corporate clients to monitor rides in real-time. This feature increases safety, ensures accountability, and provides peace of mind to both employers and employees."
  },
  {
    "WhyChooseheading": "Transparent and Detailed Billing to Simplify Expense Management",
    "WhyChoosedescription": "Our billing process is clear and comprehensive, providing detailed invoices with trip logs and fare breakdowns. This transparency aids corporate finance teams in tracking transportation expenses accurately and efficiently."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Protocols",
    "WhyChoosedescription": "In line with health and safety guidelines, our vehicles undergo regular sanitization, and drivers adhere to hygiene protocols to maintain a safe travel environment for all passengers."
  },
  {
    "WhyChooseheading": "Dedicated Account Managers for Personalized Corporate Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who assists with bookings, addresses queries promptly, and offers customized solutions to ensure a hassle-free transportation experience."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas around Dharashiv MIDC are covered by your services?",
      answer: "We cover Dharashiv MIDC and its surrounding industrial zones, providing efficient transportation solutions for all major business areas."
    },
    {
      question: "Can we book recurring rides for employees with fixed shifts?",
      answer: "Yes, we offer recurring ride schedules that align with your employees’ shift timings, ensuring consistent and reliable transport."
    },
    {
      question: "Do you provide monthly billing options for corporate clients?",
      answer: "Absolutely. We generate detailed monthly invoices with transparent fare breakdowns to facilitate easy expense management."
    },
    {
      question: "Are your drivers trained in corporate etiquette and safety?",
      answer: "Yes, our drivers are trained in professionalism, safety standards, and local route navigation to deliver the best service."
    },
    {
      question: "How do you ensure the safety of passengers during rides?",
      answer: "We implement real-time GPS tracking, conduct regular vehicle maintenance, and follow strict hygiene protocols to ensure passenger safety."
    },
    {
      question: "Is there dedicated support for corporate clients?",
      answer: "Yes, corporate clients have access to dedicated account managers and a priority helpline for personalized assistance."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Sandeep Kulkarni",
    designation: "Operations Manager, Dharashiv Manufacturing Co.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s services have significantly improved our employee commute efficiency and overall satisfaction. Their professionalism is unmatched.”"
  },
  {
    name: "Ms. Anjali Patil",
    designation: "HR Executive, Dharashiv AgroTech",
    rating: [1, 1, 1, 1, 1],
    text: "“The flexible booking options and dedicated support from eTravo have made our corporate transportation management effortless.”"
  }
];
































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Dharashiv MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-dharashiv-midc.jpg",
  "description": "Reliable corporate cab service in Dharashiv MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-dharashiv-midc"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab Service in Dharashiv MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Dharashiv MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/79.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinsharashiv;